import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

/**
 * Site footer containing navigation links and copyright notice.
 */
function Footer() {
  return (
    <footer className="footer">
      <div className="footer__content">
        <div>
          <div className="footer__logo">SabCore</div>
          <p className="footer__description">
            Next-generation load testing platform powered by AI
          </p>
        </div>

        <div className="footer__links">
          <div className="footer__section">
            <h4>Product</h4>
            <Link to="/about">About</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/demo">Request Demo</Link>
          </div>

          <div className="footer__section">
            <h4>Company</h4>
            <Link to="/career">Careers</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer__section">
            <h4>Legal</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p>&copy; {new Date().getFullYear()} SabCore. All rights reserved.</p>
        <p>SAB CORE LLC (EIN: 30-1412310)</p>
      </div>
    </footer>
  );
}

export default Footer;
